import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Avatar,
  Button,
  Menu,
  Box,
  MenuItem,
  Typography,
  IconButton,
} from "@mui/material";
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  LogoutRounded as LogoutRoundedIcon,
} from "@mui/icons-material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import {
  logout,
  setUserReducer,
  setUserRole,
} from "../../../store/slices/auth-slice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { mono } from "../../../Theme/fonts";
import api from "../../../api";
import Endpoints from "../../../api/Endpoints";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 10,
    minWidth: 180,
    color: "#1e293b",
    marginTop: "8px",
    border: "1px solid #e8eaef",
    boxShadow: "0 8px 30px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)",
    "& .MuiMenu-list": {
      padding: "6px",
    },
    "& .MuiMenuItem-root": {
      borderRadius: "6px",
      padding: "10px 12px",
      gap: "10px",
      fontSize: "13px",
      fontWeight: 500,
      color: "#475569",
      transition: "all 0.15s ease",
      "& .MuiSvgIcon-root": {
        fontSize: "17px",
        color: "#94a3b8",
        transition: "color 0.15s ease",
      },
      "&:hover": {
        backgroundColor: "#f4f7fa",
        color: "#1e293b",
        "& .MuiSvgIcon-root": {
          color: "#0085E5",
        },
      },
      "&:active": {
        backgroundColor: "#eef0f4",
      },
    },
  },
}));

export default function UserAvatarMenu({
  name = "Admin",
  role = "Admin",
  avatarSrc = "https://placehold.co/300?text=A",
  nameColor = "#fff",
  roleColor = "primary.textPrimary",
}) {
  const { userObject } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleProfileNavigation = () => {
    handleClose();
    navigate(`/settings`);
  };
  const handleSignOut = () => {
    api.post(Endpoints.LOGOUT).catch(() => {});
    dispatch(logout());
    setAnchorEl(null);
  };
  return (
    <Box>
      <Button
        id="custom-menu-button"
        aria-controls={open ? "custom-menu-body" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disableRipple={true}
        disableTouchRipple={true}
        disableFocusRipple={true}
        variant="transparent-menu-btn"
        disableElevation
        onClick={handleClick}
        endIcon={
          <KeyboardArrowDownIcon
            sx={{
              color: "#94a3b8",
              fontSize: "18px !important",
              display: { xs: "none", sm: "inline" },
              transition: "transform 0.25s cubic-bezier(0.23, 1, 0.32, 1)",
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        }
        sx={{
          px: "6px",
          py: "4px",
          borderRadius: "8px",
          transition: "background-color 0.2s ease",
          "&:hover": {
            backgroundColor: "#f4f6f9",
          },
        }}
      >
        <Box sx={{ display: "flex", gap: "0.6rem", alignItems: "center" }}>
          <Avatar
            src={process.env.REACT_APP_IMAGE_BASE_URL + userObject?.avatar}
            alt={userObject?.first_name || ""}
            sx={{
              borderRadius: "8px",
              color: "white",
              width: "32px !important",
              height: "32px !important",
              fontSize: "14px",
              backgroundColor: "#0085E5",
              boxShadow: "0 1px 4px rgba(0,133,229,0.2)",
            }}
          />
          {userObject?.first_name ||
          (userObject?.last_name && userObject?.Role?.display_name) ? (
            <Box
              sx={{
                display: { xs: "none", sm: "flex" },
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: "13px",
                  color: nameColor,
                  fontWeight: 600,
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  lineHeight: 1.3,
                }}
              >
                {(
                  userObject?.first_name +
                  " " +
                  userObject?.last_name
                ).substring(0, 25)}
              </Typography>
              <Typography
                sx={{
                  fontFamily: mono,
                  fontSize: "9px",
                  color: "#94a3b8",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  lineHeight: 1.3,
                }}
              >
                {userObject?.Role?.display_name}
              </Typography>
            </Box>
          ) : null}
        </Box>
      </Button>
      <StyledMenu
        id="custom-menu-body"
        MenuListProps={{
          "aria-labelledby": "custom-menu-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleProfileNavigation}>
          <AccountCircleOutlinedIcon />
          Profile
        </MenuItem>
        <MenuItem
          onClick={handleSignOut}
          sx={{
            "&:hover": {
              backgroundColor: "#fef2f2 !important",
              color: "#b91c1c !important",
              "& .MuiSvgIcon-root": {
                color: "#b91c1c !important",
              },
            },
          }}
        >
          <LogoutRoundedIcon />
          Sign out
        </MenuItem>
      </StyledMenu>
    </Box>
  );
}
